import { c as _c } from "react/compiler-runtime";
import { ChangeEmailView } from "@repo/ui/components/profile/ChangeEmailView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/mitt-konto/andra-epost")({
  component: ChangeEmailPage
});
function ChangeEmailPage() {
  const $ = _c(2);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    t0 = /*#__PURE__*/_jsx(ChangeEmailView, {
      authClient: authClient,
      onSuccess: () => navigate({
        to: "/mitt-konto"
      }),
      onBack: () => navigate({
        to: "/mitt-konto"
      }),
      statusMessage: null
    });
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}